module.exports = __webpack_public_path__ + "img/phone_b.f515a550.svg";